import { createContext } from 'react'

const noop = () => {}

/**
 * @typedef {Object} TTXUserCtx
 * @property {string} userId
 * @property {string} incidentId
 * @property {string} simulationId
 */

/**
 * @type {ReturnType<typeof createContext<TTXUserCtx>>}
 */
export const TTXUserCtx = createContext({
    userId: null,
    incidentId: null,
    simulationId: null,
})

TTXUserCtx.displayName = 'TTXUserCtx'

export default TTXUserCtx
